(ns common.schema.entities.investor.core
  (:require [common.roles :as roles]
            [common.schema.entities.investor.schema :as investor]))

;; Verbatim copy of common.schema.entity-types's shared crm-delete-check-fn,
;; called by investor's existing disable-permissions-check-fn - required
;; here, not there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- crm-delete-check-fn
  [{:keys [tr role]}]
  (when-not (roles/user? role)
    (tr :not-allowed)))

(defn- disable-permissions-check-fn
  [{:keys [entity tr] :as ctx}]
  (or (crm-delete-check-fn ctx)
      (when (->> entity
                 :exit-opportunity/_buyer
                 (remove :common/disabled?)
                 (seq))
        (tr :cannot-delete-when-buyer-candidate-in-exit-opportunities))))

(def entity-type-definition
  {:entity-type                  :entity.type/investor
   :schema                       investor/schema
   :name                         {:en "Investor"}
   :plural                       {:en "Investors"}
   :icon                         :fa-user-tie
   :create-icon                  :fa-user-tie
   :read-permissions-check-fn    (fn [{:keys [account-current-permissions]}]
                                   (contains? (:account-modules account-current-permissions)
                                              :module/fundraising))
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: investor's dedicated OpenSearch index already exists
   ;; and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false

   :search                       {:result/title-attr    :investor/name
                                  :list/default-columns [:investor/name
                                                         :investor/type
                                                         :investor/legal-entity
                                                         :investor/kyc-status
                                                         :investor/tag-tags
                                                         :common/updated-on]
                                  :views                {:grid {:po-default-field-paths [[:investor/name]
                                                                                         [:investor/type]
                                                                                         [:investor/legal-entity]
                                                                                         [:investor/kyc-status]
                                                                                         [:investor/tag-tags]
                                                                                         [:common/updated-on]]
                                                                :mandatory-field-paths  [[:investor/name]]}}}})
